import { helper } from '@ember/component/helper';
export function concatClass(params) {
  return params.filter(Boolean).join(' ');
}
export default helper(concatClass);